<template>
  <div>
    <h1 class="title">{{ $t("workspace.members") }}</h1>
    <div class="breadcrumb-new"></div>

    <div class="table-responsive mb-0" v-if="pagination && pagination.docs.length > 0">
      <table class="table table-centered table-nowrap">
        <tbody>
          <tr v-for="item in pagination.docs" :key="item._id" class="hider">
            <td style="width: 50px;">
              <letter-avatar :name="item.name" :image="item.logo" variant="secondary"> </letter-avatar>
            </td>
            <td>
              <h5 class="font-size-14 m-0">
                {{ item.name }}
              </h5>
              <h5 class="font-size-14 m-0 mt-1">
                {{ item.email }}
              </h5>
            </td>
            <td>
              <multiselect
                :value="memberRole(item)"
                track-by="definition"
                :placeholder="$t('workspace.role')"
                :options="workspaceRoles"
                :searchable="false"
                :allow-empty="false"
                :show-labels="false"
                @select="memberRoleSelected($event, item)"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div>
                    <b> <i class="mdi mdi-account-circle"></i> {{ option.name | translate }} </b>

                    <div v-html="$options.filters.translate(option.description)"></div>
                  </div>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <b> <i class="mdi mdi-account-circle"></i> {{ option.name | translate }} </b>
                  <div v-html="$options.filters.translate(option.description)"></div>
                </template>
              </multiselect>
            </td>
            <td>
              <i
                v-if="item.edited"
                class="mdi mdi-check-bold text-success hand"
                v-b-tooltip.hover
                :title="$t('common.save')"
                @click="updateMemberWorkspaceRole(item)"
                style="font-size: 18px; "
              ></i>
            </td>

            <td>
              <i class="bx bx-trash-alt text-danger hand" v-b-tooltip.hover :title="$t('common.delete')" @click="removeMember(item)" style="font-size: 18px; margin-top: 6px;"></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center mt-auto">
        <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10"></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { maxLength, minLength, required } from "vuelidate/lib/validators";

const state = "managementWorkspace";
export default {
  components: {},

  props: { workspace: { type: Object, required: true } },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10 },
        query: {},
      },

      form: { _id: undefined, name: undefined },
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(30),
      },
    },
  },
  watch: {
    workspace: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
  },
  computed: {
    memberRole() {
      return (item) => {
        const workspaceRole = this.$store.getters[`${state}/roleByMemberId`](item._id);
        return workspaceRole;
      };
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },

    pagination() {
      return this.$store.getters[`${state}/paginationMember`];
    },

    workspaceRoles() {
      return this.$store.getters["workspaceRole/roles"];
    },
  },
  mounted() {},
  methods: {
    async updateMemberWorkspaceRole(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/updateMemberWorkspaceRole`, {
          workspace: this.workspace,
          member: { _id: item._id },
          workspaceRole: item.workspaceRole,
        });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {}
      this.markAsEdited(item, false);
      this.$forceUpdate();
    },

    async removeMember(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/removeMember`, { memberId: item._id, ownerId: this.workspace.owner._id });
        this.$toast.success(this.$t("common.delete-successful"));
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    memberRoleSelected(role, member) {
      this.markAsEdited(member, true);
      this.$store.commit(`${state}/memberRole`, { member, role });
    },
    markAsEdited(member, edited) {
      this.$store.commit(`${state}/memberEdited`, { member, edited });
    },
    paginate() {
      const req = { ...this.request, query: { workspace: this.workspace } };

      this.$store.dispatch(`${state}/paginateMember`, { pagination: req, id: this.workspace?._id });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("./workspace-members.scss");
</style>
